<template>
  <v-container class="pa-0">
    <v-carousel
      :continuous="false"
      :cycle="false"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      v-on:change="swipeChange"
      height="220"
    >
      <v-carousel-item>
        <v-row class="ma-0">
          <v-col class="pa-2 mb-4" cols="6">
            <state-table
              :visible="true"
              title="사이트 현황"
              stateName="총 사이트 수"
              :state-value="siteTotal.totalCount"
              :run-val="siteTotal.runCount + siteTotal.pauseCount"
              :err-val="siteTotal.faultCount"
              :str-val="siteTotal.errorCount"
            ></state-table>
          </v-col>
          <v-col class="pa-2 mb-4" cols="6">
            <state-table
              :visible="true"
              title="인버터 현황"
              stateName="총 인버터 수"
              :state-value="inverterTotal.totalCount"
              :run-val="inverterTotal.runCount + inverterTotal.pauseCount"
              :err-val="inverterTotal.faultCount"
              :str-val="inverterTotal.errorCount"
            ></state-table>
          </v-col>
        </v-row>
      </v-carousel-item>
      <v-carousel-item>
        <v-row no-gutters>
          <v-col class="pa-2 mb-4" cols="6">
            <gauge-card
              title="전일 발전량"
              :max="Math.round((siteTotal.totalCapacity * 1.1))"
              :value="isNaN(yesterActive) ? 0: Math.round(yesterActive)"
              color="#90F072"
              :flag="refreshFlag"
              :isDark="isDark"
              unit="kWh"
            ></gauge-card>
          </v-col>
          <v-col class="pa-2 mb-4" cols="6">
            <gauge-card
              title="당일 발전량"
              :max="Math.round((siteTotal.totalCapacity * 1.1))"
              :value="isNaN(siteTotal.pvpcsDailyP) ? 0: Math.round(siteTotal.pvpcsDailyP)"
              color="#90F072"
              :flag="refreshFlag"
              :isDark="isDark"
              unit="kWh"
            ></gauge-card>
          </v-col>
        </v-row>
      </v-carousel-item>
      <v-carousel-item>
        <v-row no-gutters>
          <v-col class="pa-2 pt-4 mb-4" cols="12">
            <text-card
              title="당일예상발전금액"
              :max="Math.round((siteTotal.totalCapacity * 1.1) /1000)"
              :value="isNaN(siteTotal.expectPrice) ? 0:Math.round(siteTotal.expectPrice)"
              color="#3392e3"
              :flag="refreshFlag"
            ></text-card>
          </v-col>
        </v-row>
      </v-carousel-item>
      <v-carousel-item>
        <v-row no-gutters>
          <v-col class="pa-2 mb-4" cols="6">
            <gauge-card
              title="전일 발전시간"
              :max="9"
              :value="yesterActiveTime"
              color="#FFD754"
              :flag="refreshFlag"
              :isDark="isDark"
              unit="hr"
            ></gauge-card>
          </v-col>
          <v-col class="pa-2 mb-4" cols="6">
            <gauge-card
              title="당일 발전시간"
              :max="9"
              :value="siteTotal.dailyTime"
              color="#FFD754"
              :flag="refreshFlag"
              :isDark="isDark"
              unit="hr"
            ></gauge-card>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import StateTable from '@/components/mobile/StateTable.vue'
import {
  getMonitoringTotal,
  getMonitoringTotalY
} from '@/api/monitoring/monitoring'
import GaugeCard from '@/components/mobile/m_GaugeCard.vue'
import TextCard from '@/components/mobile/WillPrice.vue'
import store from '@/store'
import { clearInterval } from 'timers'

export default {
  name: 'swipe',
  components: {
    StateTable,
    GaugeCard,
    TextCard
  },
  data() {
    return {
      isDark: false,
      intervalFunction: '',
      transition: 'slide-next',
      activetab: 0,
      tabwidth: 135,
      items: ['Status', 'p_generation', 'price', 'time'],
      touch: { sx: null, sy: null, st: null, ex: null, ey: null, et: null },
      yesterActive: 0,
      yesterActiveTime: 0,
      secon: null,
      scroll: null,
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      refreshFlag: 0,
      kwCnt: 0,
      hrCnt: 0
    }
  },
  mounted() {
    // this.$refs.tabbar.style.setProperty('--tabwidth', this.tabwidth + 'px')
    this.isDark = this.$vuetify.theme.isDark
    this.refreshFlag++
    this.getMonitorData()
    this.intervalFunction = setInterval(() => {
      this.getMonitorData()
    }, 120000)
    this.getYesterDayData()
  },
  computed: {
    pointer() {
      if (window.PointerEvent) return true
      else return false
    }
  },
  watch: {
    '$vuetify.theme.isDark'() {
      this.isDark = this.$vuetify.theme.isDark
      this.refreshFlag++
    }
  },
  methods: {
    swipeChange(n) {
      this.refreshFlag++
    },
    getYesterDayData() {
      const _this = this
      // 전일 발전량이랑 전일 발전 시간 가져오기
      getMonitoringTotalY(store.state.user.userId).then(res => {
        _this.yesterActive = res.PVPCS_Daily_P
        _this.yesterActiveTime = res.Daily_Time
      })
    },
    getMonitorData() {
      getMonitoringTotal(store.state.user.userId).then(res => {
        if (res.siteTotal) {
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = res.inverterTotal
        }
        // Object.keys(res.sido).forEach(key => {
        //   this.sidoFlag.push(key)
        // })
        // this.sidoData = res.sido
        this.refreshFlag++
      })
    }
  },
  destroyed() {
    clearInterval(this.intervalFunction)
  }
}
</script>

<style lang="scss" scoped>
</style>
